import TechnologyView from './TechnologyView'

export default TechnologyView
